// extracted by mini-css-extract-plugin
module.exports = {"fadeEdges":"featured_fadeEdges__Vo8Y8"};